<template>
  <li class="block [&_>_ul_li]:ml-3 [&_>_ul_li]:pl-3 [&_>_ul_li]:border-l-surfaces-neutral [&_>_ul_li]:border-l [&_>_ul_li]:border-l-solid">
    <button
      :id="dataTestId"
      :data-test-id="dataTestId"
      class="text-primary outline-none gap-3 font-medium hover:text-brand hover:cursor-pointer cursor-pointer text-sm h-9 p-2 rounded-lg flex flex-row items-center w-full"
      :class="[
        isActive ? 'bg-brand-light ' : 'hover:bg-surface focus:bg-surface',
      ]"
      :aria-label="`Navigate to page - ${label}`"
      :aria-expanded="$slots.children ? 'true' : undefined"
      :aria-current="isActive ? 'page' : undefined"
      :aria-controls="$slots.children ? `nav-children-${dataTestId}` : undefined"
      @click="handleClick"
    >
      <slot name="left" />
      <span class=" truncate text-ellipsis text-[var(--font-colour-primary)]">
        {{ label }}
      </span>
      <slot name="right" />
    </button>
    <ul
      v-if="$slots.children"
      :id="`nav-children-${dataTestId}`"
      role="menu"
      :aria-labelledby="dataTestId"
    >
      <slot name="children" />
    </ul>
  </li>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { generateDataTestId } from '@/components/am3-generic/core/dataTestId'

interface Props {
  label: string
  isActive?: boolean
  action?: () => void
}

const props = withDefaults(defineProps<Props>(), {
  isActive: false,
  action: undefined,
})

const dataTestId = computed(() => `secondary-nav-item_${generateDataTestId(props.label)}`)

const handleClick = () => {
  if (props.action) {
    props.action()
  }
}
</script>
